<mat-dialog-content class="mat-typography">
    <div fxLayout="row" *ngIf="navigation === 'back' && !isUploadPanel">
        <i (click)="dialogRef.close(false)" class="fal fa-times"></i>

        <div fxLayout="column">
            <span class="title" mat-dialog-title>Let’s start with adding your Internal Staff</span>

        </div>
        <div fxLayout="column">
            <div class="description-shift-alert">
                <div class="description-text">
                    <span class="description-title">What is Shift Alerts?</span>
                    <p class="description-paragraph">
                        Have an open shift that you’d like to offer to one of more of your Internal Staff?
                         <strong>Shift Alerts</strong> 
                        makes it easy. Minutes  to set up, and your staff can <strong> see and accept open shifts right on their mobile phones.</strong>

                    </p>
                </div>
                <img class="description-icon" src="../../../../../assets/images/on-your-way.svg" alt="">

            </div>
        </div>

    </div>
    <i *ngIf="navigation === 'next'" (click)="dialogRef.close(false)" class="fal fa-times"></i>
    <app-onboarding-add-staff (uploadFile)="isUploadPanel = $event" *ngIf="navigation === 'back'" (nextClicked)="navigation = 'next'" [usedInsideApp]="true">
    </app-onboarding-add-staff>
    <app-confirm-staff *ngIf="navigation === 'next'" [usedInApp]="true" (backClicked)="goBack()">
    </app-confirm-staff>
</mat-dialog-content>